import type { ReactNode } from "react";
import { IonModal } from "@ionic/react";
import { cn } from "../../lib/utils";

interface BottomSheetProps {
  isOpen: boolean;
  onDismiss: () => void;
  /** Accessible name for the dialog. */
  label: string;
  children: ReactNode;
  /** Sheet heights as fractions of the viewport. */
  breakpoints?: number[];
  initialBreakpoint?: number;
  className?: string;
}

/**
 * Draggable bottom sheet built on Ionic's sheet modal. Includes a grab handle,
 * dimmed backdrop, swipe-to-dismiss and Escape-to-close.
 */
export function BottomSheet({
  isOpen,
  onDismiss,
  label,
  children,
  breakpoints = [0, 0.75, 0.95],
  initialBreakpoint = 0.75,
  className,
}: BottomSheetProps) {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      breakpoints={breakpoints}
      initialBreakpoint={initialBreakpoint}
      handle
      handleBehavior="cycle"
      aria-label={label}
      className={cn("tidy-sheet", className)}
    >
      <div className="h-full overflow-y-auto px-4 pt-5 pb-[calc(env(safe-area-inset-bottom)+24px)]">
        {children}
      </div>
    </IonModal>
  );
}

export default BottomSheet;
